// src/components/DrawingCanvas/TypeMenuOverlay.jsx
//
// Secili nesne tipine gore uygun TypeMenu component'ini renderlar.

import React from 'react';

import { FixtureTypeMenu as LightFixtureTypeMenu } from '../../modules/tesisat';
import { PanelTypeMenu } from '../../modules/panel';
import { SocketTypeMenu } from '../../modules/tesisat';
import { LightSwitchTypeMenu } from '../../modules/tesisat';
import MainPanelTypeMenu from '../TypeMenus/MainPanelTypeMenu';
import { MachineTypeMenu } from '../../modules/tesisat';
import BoxTypeMenu from '../TypeMenus/BoxTypeMenu';
import CabinTypeMenu from '../TypeMenus/CabinTypeMenu';
import BellTypeMenu from '../TypeMenus/BellTypeMenu';
import { CableShaftTypeMenu } from '../../modules/tesisat';

export default function TypeMenuOverlay({ menus, handleDrag, handleClose, scene }) {
  return <>
    {menus.socket.visible && (
      <SocketTypeMenu
        x={menus.socket.position.x + 50}
        y={menus.socket.position.y + 30}
        onClose={() => handleClose('socket')}
        details={{ id: menus.socket.id }}
        scene={scene}
        onDrag={(dx, dy) => handleDrag('socket', dx, dy)}
      />
    )}

    {menus.lightSwitch.visible && (
      <LightSwitchTypeMenu
        x={menus.lightSwitch.position.x}
        y={menus.lightSwitch.position.y}
        onClose={() => handleClose('lightSwitch')}
        details={{ id: menus.lightSwitch.id }}
        scene={scene}
        onDrag={(dx, dy) => handleDrag('lightSwitch', dx, dy)}
      />
    )}

    {menus.lightFixture.visible && (
      <LightFixtureTypeMenu
        scene={scene}
        x={menus.lightFixture.position.x}
        y={menus.lightFixture.position.y}
        value={menus.lightFixture.userData?.subtype || 'normal'}
        fixtureDetails={{ 'ID': menus.lightFixture.id }}
        onDrag={(dx, dy) => handleDrag('lightFixture', dx, dy)}
        onClose={() => handleClose('lightFixture')}
      />
    )}

    {menus.panel.visible && (
      <PanelTypeMenu
        scene={scene}
        x={menus.panel.position.x}
        y={menus.panel.position.y}
        panelDetails={menus.panel.details}
        onAddPositionChange={() => {}}
        onDrag={(dx, dy) => handleDrag('panel', dx, dy)}
        onClose={() => handleClose('panel')}
      />
    )}

    {menus.cabin.visible && (
      <CabinTypeMenu
        scene={scene}
        x={menus.cabin.position.x}
        y={menus.cabin.position.y}
        cabinDetails={menus.cabin.details}
        onAddPositionChange={() => {}}
        onDrag={(dx, dy) => handleDrag('cabin', dx, dy)}
        onClose={() => handleClose('cabin')}
      />
    )}

    {menus.mainPanel.visible && (
      <MainPanelTypeMenu
        scene={scene}
        x={menus.mainPanel.position.x}
        y={menus.mainPanel.position.y}
        mainPanelDetails={menus.mainPanel.details}
        onAddPositionChange={() => {}}
        onDrag={(dx, dy) => handleDrag('mainPanel', dx, dy)}
        onClose={() => handleClose('mainPanel')}
      />
    )}

    {menus.box.visible && (
      <BoxTypeMenu
        scene={scene}
        x={menus.box.position.x}
        y={menus.box.position.y}
        boxDetails={menus.box.details}
        onAddPositionChange={() => {}}
        onDrag={(dx, dy) => handleDrag('box', dx, dy)}
        onClose={() => handleClose('box')}
      />
    )}

    {menus.machine.visible && (
      <MachineTypeMenu
        scene={scene}
        x={menus.machine.position.x}
        y={menus.machine.position.y}
        machineDetails={menus.machine.details}
        onAddPositionChange={() => {}}
        onDrag={(dx, dy) => handleDrag('machine', dx, dy)}
        onClose={() => handleClose('machine')}
      />
    )}

    {menus.bell.visible && (
      <BellTypeMenu
        scene={scene}
        x={menus.bell.position.x}
        y={menus.bell.position.y}
        details={{ id: menus.bell.id }}
        onDrag={(dx, dy) => handleDrag('bell', dx, dy)}
        onClose={() => handleClose('bell')}
      />
    )}

    {menus.cableShaft.visible && (
      <CableShaftTypeMenu
        scene={scene}
        x={menus.cableShaft.position.x}
        y={menus.cableShaft.position.y}
        cableShaftDetails={menus.cableShaft.details}
        onDrag={(dx, dy) => handleDrag('cableShaft', dx, dy)}
        onClose={() => handleClose('cableShaft')}
        onContinueWire={() => {}}
      />
    )}
  </>;
}
